import { render, staticRenderFns } from "./MethodSelector.vue?vue&type=template&id=ff481260&scoped=true"
import script from "./MethodSelector.vue?vue&type=script&lang=js"
export * from "./MethodSelector.vue?vue&type=script&lang=js"
import style0 from "@pds/card/card.min.css?vue&type=style&index=0&id=ff481260&prod&scoped=true&lang=css&external"
import style1 from "@pds/button/button.min.css?vue&type=style&index=1&id=ff481260&prod&scoped=true&lang=css&external"
import style2 from "@pds/typography/typography.min.css?vue&type=style&index=2&id=ff481260&prod&scoped=true&lang=css&external"
import style3 from "./MethodSelector.vue?vue&type=style&index=3&id=ff481260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff481260",
  null
  
)

export default component.exports